import { render, staticRenderFns } from "./QPcodingTest.vue?vue&type=template&id=d0621e60"
import script from "./QPcodingTest.vue?vue&type=script&lang=js"
export * from "./QPcodingTest.vue?vue&type=script&lang=js"
import style0 from "./QPcodingTest.vue?vue&type=style&index=0&id=d0621e60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports